export const css = {
	root: '_2bSUsSpv',
	input: 'KUuUA1Kk',
	edit: '_1CjFq7CN',
	' _key': 'certwise-theme/dojo/grid-cell'
};

export default css;
